module.exports = __webpack_public_path__ + "img/mi-dashboard.d664d138.svg";